import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { OperationState } from 'src/app/core/services/operations/base/operation-state';
import { SaveOperationsService } from 'src/app/core/services/operations/save/save-operations.service';

@Component({
  selector: 'bom-save-indicator',
  templateUrl: './save-indicator.component.html',
  styleUrls: ['./save-indicator.component.scss'],
})
export class SaveIndicatorComponent implements OnInit, OnDestroy {
  @Input()
  coloredBackground = false;

  saveOperationState$: Observable<OperationState>;
  OperationState = OperationState;

  private componentDestroyed$ = new Subject();

  constructor(public saveOperationsService: SaveOperationsService) {}

  ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  ngOnInit() {
    this.saveOperationState$ = this.saveOperationsService.operationState$;
  }
}
